"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  display: 'flex',
  zIndex: 'layer8',
  justifyContent: 'center',
  alignItems: {
    base: 'flex-end',
    tablet: 'center'
  },
  height: '100%',
  minHeight: '-moz-available',
  minHeight: '-webkit-fill-available',
  minHeight: 'fill-available'
};